import { cn as e } from "../shared/utils.js";
import { PassiveTooltip as t } from "./passive-tooltip.js";
import { useEffect as n, useRef as r, useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
import { useResizeObserver as o } from "usehooks-ts";
//#region src/tooltip/tooltip-text-overflow.tsx
function s({ children: s, className: c, tooltipContent: l = s, ...u }) {
	let d = r(null), [f, p] = i(!1), { width: m } = o({ ref: d });
	return n(() => {
		let e = d.current;
		p(!!(e && e.scrollWidth > e.clientWidth));
	}, [s, m]), /* @__PURE__ */ a(t, {
		ref: d,
		content: l,
		disabled: !f,
		positionerProps: {
			align: "center",
			side: "top"
		},
		trigger: s,
		triggerProps: {
			...u,
			className: e("inline-block max-w-full min-w-0 truncate align-bottom", c)
		}
	});
}
//#endregion
export { s as TooltipTextOverflow };
